import React from 'react';
import { Link } from "react-router-dom";
import {
  Navbar,
  Nav,
  NavItem,
  NavbarBrand,
  Container
} from "reactstrap";

export const Heading = () => {
  return (
    <Navbar color="dark" dark >
      <Container>
        <NavbarBrand href="/">SWIFTWAY CARGO</NavbarBrand>
        <h2 style={{color:"white"}}>ALL PACKAGES</h2>
        <Nav>
          <NavItem>
            <Link className="btn btn-primary" to="/add">Add New Package</Link>
          </NavItem>
        </Nav>

      </Container>
    </Navbar>
  )
}
